import { ReactElement } from 'react';
import { Text, Link, TextProps } from '@chakra-ui/react';
import { ExternalRoutes } from 'types/Routes';

export const TermsPrivacyText = (props: TextProps): ReactElement => {
  return (
    <Text width="100%" textStyle="body.s.regular" textAlign="center" {...props}>
      Indem du fortfährst, akzeptierst du unsere{' '}
      <Link
        href={ExternalRoutes.TERMS}
        color="text.info"
        target="_blank"
        rel="noopener noreferrer"
        textStyle="body.s.regular"
      >
        Nutzungsbedingungen
      </Link>
      .
      <br />
      Für weitere Informationen siehe unsere{' '}
      <Link
        color="text.info"
        href={ExternalRoutes.PRIVACY}
        display="inline"
        target="_blank"
        rel="noopener noreferrer"
        textStyle="body.s.regular"
      >
        Datenschutzerklärung
      </Link>
      .
    </Text>
  );
};
